import React, { useCallback, useReducer } from 'react';
import type { FormIOSchema } from '@formio/react';
import { FormBuilder } from '@formio/react';
import { HBox } from '../layout';

export type FormIoBuilderProps = {
  onChange: (schema: FormIOSchema) => void;
  form: FormIOSchema;
};
export function FormioBuilder({
  onChange,
  form
}: FormIoBuilderProps): React.JSX.Element {
  return <FormBuilder onChange={onChange} form={form} errors={{}} />;
}

export type FormioAction = {
  type: 'set';
  payload: FormIOSchema;
};
export function formioSchemaReducer(
  state: FormIOSchema,
  action: FormioAction
): FormIOSchema {
  if (action.type === 'set') {
    return { ...action.payload };
  }
  return { ...state };
}

export const init: FormIOSchema = {
  components: []
};

export function FormIoStandalone(): React.JSX.Element {
  const [schema, reduce] = useReducer(formioSchemaReducer, init);
  const onChange = useCallback(
    (data: FormIOSchema) => reduce({ type: 'set', payload: data }),
    []
  );
  return <FormioBuilder onChange={onChange} form={schema} />;
}
